import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { postData, getData } from "../../../../ApiServices/ApiService";
import {
    ORG_GET_SERVICE_LIST_SEARCH, ORG_GET_SUB_SERVICE_LIST_SEARCH,
    ORG_GET_SCHEDULE_REPORT, ORG_OVERVIEW_REPORT, ORG_TASK_STATUS, ORG_DATE_STATUS, ORG_CHECKWISE_STATUS, ORG_GET_NOTIFICATIONS_LIST_DASHBOARD, ORG_GET_GROUP_LIST, ORG_GET_ALL_CODES_LIST
} from "../../../../ApiServices/BaseURL";

const GstServiceController = () => {
    const [serviceOptions, setServiceOptions] = useState([]);
    const [serviceSubOptions, setServiceSubOptions] = useState([]);
    const [statusOptions, setStatusOptions] = useState([
        { label: "Completed", value: 3 },
        { label: "Pending", value: 8 },
    ]);
    const [taskOverview, setTaskOverview] = useState([
        { label: "Completed", key: "completed", value: "--" },
        { label: "Priority", key: "priority", value: "--" },
        { label: "In Progress", key: "inprogress", value: "--" },
        { label: "Not Started", key: "not_started", value: "--" },
        { label: "Hold", key: "hold", value: "--" },
        { label: "Delayed", key: "delayed", value: "--" },
        { label: "Long Due", key: "long_due", value: "--" },
    ]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [servicesLoading, setServicesLoading] = useState(false);
    const [servicesError, setServicesError] = useState('');
    const [serviceName, setServiceName] = useState('');
    const [subServiceName, setSubServiceName] = useState('');
    const [subServicesLoading, setSubServicesLoading] = useState(false);
    const [subServicesError, setSubServicesError] = useState('');
    const [overViewLoading, setOverViewLoading] = useState(false);
    const [overViewReportError, setOverViewReportError] = useState('');
    const [taskStatus, setTaskStatus] = useState([
        { label: "Task with Pending Issues", key: "task_with_pending_issues", value: "--" },
        { label: "Tasks kept on Hold", key: "tasks_kept_on_hold", value: "--" },
        { label: "Tasks with No Issues", key: "tasks_with_no_issues", value: "--" },
    ]);
    const [taskStatusLoading, setTaskStatusLoading] = useState(false);
    const [taskStatusError, setTaskStatusError] = useState('');
    const [dateStatus, setDatetatus] = useState([
        { label: "Due by Today", key: "due_by_today", value: "--" },
        { label: "Due within 7 Days", key: "due_within_7_days", value: "--" },
        { label: "Crossed Due Date", key: "crossed_due_date", value: "--" },
    ]);
    const [dateStatusLoading, setDateStatusLoading] = useState(false);
    const [dateStatusError, setDateStatusError] = useState('');
    const [checkwiseStatusList, setCheckwiseStatusList] = useState([])
    const [checkwiseStatus, setCheckwiseStatus] = useState([
        { label: "Info received from client for GSTR1", key: "info_received_from_clients_for_gstr1", value: "--" },
        { label: "Preparation of GSTR1", key: "preparation_of_gstr1", value: "--" },
        { label: "Checking for GSTR1", key: "checking_for_gstr1", value: "--" },
        { label: "Submission of GStr1", key: "submission_of_gstr1", value: "--" },
        { label: "Filling GSTR1", key: "filling_gstr1", value: "--" },
    ]);
    const [checkwiseStatusLoading, setCheckwiseStatusLoading] = useState(false);
    const [checkwiseStatusError, setCheckwiseStatusError] = useState('');
    const [scheduleInfoListLoading, setScheduleInfoListLoading] = useState([
        { label: "Follow Ups", key: "due_by_today", value: "--" },
        { label: "Appointments", key: "due_within_7_days", value: "--" },
        { label: "Meetings", key: "crossed_due_date", value: "--" },
    ]);

    const [taskCheckList, setTaskCheckList] = useState([])
    const [taskCheckLoading, setTaskCheckLoading] = useState(false)
    const [taskCheckError, setTaskCheckError] = useState('')
    const [scheduleInfoList, setScheduleInfoList] = useState([]);
    const [scheduleResError, setScheduleResError] = useState('');
    const [scheduleLoading, setScheduleLoading] = useState(false);

    const [selectedService, setSelectedService] = useState(null);
    const [selectedServiceCategory, setSelectedServiceCategory] = useState(null);

    const [grouperror, setGroupError] = useState('');
    const [groupListLoading, setGroupListLoading] = useState(false);
    const groupClientOptionsRef = useRef([]);
    const [groupClientOptions, setGroupClientOptions] = useState([]);
    const [yearListLoading, setYearListLoading] = useState(false);
    const [yearListError, setYearListError] = useState('');
    const [yearList, setYearList] = useState([]);
    const [periodList, setPeriodList] = useState([]);

    const [selectedFinancialYear, setSelectedFinancialYear] = useState("");
    const [selectedFinancialStatus, setSelectedFinancialStatus] = useState("");
    const [selectedUserwiseStatus, setSelectedUserwiseStatus] = useState("");
    const [selectedUserwiseCheck, setSelectedUserwiseCheck] = useState("");
    const [selectedOverallStatus, setSelectedOverallStatus] = useState("");
    const [selectedOverallCheck, setSelectedOverallCheck] = useState("");
    const [selectedOverallYear, setSelectedOverallYear] = useState("");
    const [selectedOverallPeriod, setSelectedOverallPeriod] = useState("");
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [selectedTaskwiseCheck, setSelectedTaskwiseCheck] = useState(null);
    const [selectedTaskCheck, setSelectedTaskCheck] = useState(null)
    const [selectedTaskCheck2, setSelectedTaskCheck2] = useState(null);

    const [countError, setCountError] = useState('');
    const [count, setCount] = useState('--');
    const [countLoading, setCountLoading] = useState(false);

    const [toDoLoading, setToDoLoading] = useState(false);
    const [toDoReportError, setToDoReportError] = useState('');

    const [userPermissions, setUserPermissions] = useState(null);
    useEffect(() => {
        const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
        setUserPermissions(storedUserInfo?.user_permissions || {});
    }, [])

    const handleCompletedCount = (value) => {
        setSelectedTaskCheck(value);
        fetchUserCount(value, selectedTaskCheck2);
    }

    const handlePendingCount = (value) => {
        setSelectedTaskCheck2(value);
        fetchUserCount(selectedTaskCheck, value);
    }

    const cards = [
        {
            title: "Financial Year Report",
            dropdowns: [
                { label: "Financial Year", options: yearList, loading: yearListLoading, error: yearListError, value: selectedFinancialYear, setValue: setSelectedFinancialYear, dropdownWidth: '70px' },
                { label: "Financial Status", options: statusOptions, loading: false, error: "", value: selectedFinancialStatus, setValue: setSelectedFinancialStatus, dropdownWidth: '84px' },
            ],
        },
    ]
    const cards2 = [
        {
            title: "Userwise Task at a Glance",
            dropdowns: [
                { label: "Userwise Status", options: taskCheckList, loading: taskCheckLoading, error: taskCheckError, value: selectedTaskCheck, setValue: setSelectedTaskCheck, function: handleCompletedCount, placeholder: "Completed Checks", dropdownWidth: '150px' },
                { label: "Userwise Checks", options: taskCheckList, loading: taskCheckLoading, error: taskCheckError, value: selectedTaskCheck2, setValue: setSelectedTaskCheck2, function: handlePendingCount, placeholder: "Pending Checks", dropdownWidth: '130px' },
            ],
        },
    ]
    const cards3 = [
        {
            title: "Overall Task at a Glance",
            dropdowns: [
                { label: "Overall Status", options: taskCheckList, loading: taskCheckLoading, error: taskCheckError, value: selectedOverallStatus, setValue: setSelectedOverallStatus, placeholder: "Completed Checks", dropdownWidth: '110px' },
                { label: "Overall Checks", options: taskCheckList, loading: taskCheckLoading, error: taskCheckError, value: selectedOverallCheck, setValue: setSelectedOverallCheck, placeholder: "Pending Checks", dropdownWidth: '110px' },
                { label: "Overall Year", options: yearList, loading: yearListLoading, error: yearListError, value: selectedOverallYear, setValue: setSelectedOverallYear, placeholder: "Select", dropdownWidth: '70px' },
                { label: "Overall Period", options: periodList, loading: yearListLoading, error: yearListError, value: selectedOverallPeriod, setValue: setSelectedOverallPeriod, placeholder: "Select", dropdownWidth: '84px' },
            ],
        },
    ];

    const cards1 = [
        {
            title: "Taskwise Group Report",
            dropdowns: [
                { label: "Group Name", options: groupClientOptions, loading: groupListLoading, error: grouperror, value: selectedGroup, setValue: setSelectedGroup, placeholder: "Group Name", dropdownWidth: '95px' },
                { label: "TaskWise Status", options: statusOptions, loading: false, error: "", value: selectedTaskwiseCheck, setValue: setSelectedTaskwiseCheck, placeholder: "Select", dropdownWidth: '84px' },
            ],
        },
    ];

    const [toDoListData, setToDoListData] = useState([
        { taskStatus: "Completed", taskwise: "--", fileNo: "--", without: "--" },
        { taskStatus: "Pending", taskwise: "--", fileNo: "--", without: "--" },
    ]);

    const fetchServices = async () => {
        setServicesLoading(true);
        setServiceOptions([]);
        setServicesError('');
        try {
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_')); // Get user info from localStorage
            const payload = {
                emp_id_auth: storedUserInfo?.emp_id,
            };

            // API call to fetch GST services
            const response = await postData(ORG_GET_SERVICE_LIST_SEARCH, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        const services = responseData?.dataJ.map((service) => ({
                            label: service.service_name,
                            value: service.service_id,
                        }));
                        setServiceOptions(services);
                        handleSubServices(services[0], 'firstTime')
                    } else {
                        setServicesError(responseData?.info || 'Service search failed.');
                    }
                } else {
                    setServicesError(responseData?.info || 'Unexpected response code from the server.');
                }
            }
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setServicesError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setServicesError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setServicesError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setServicesError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setServicesError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to get service options. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setServicesError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setServicesError(`Failed to search service options. Please check your network connection and try again.`);
            }
        } finally {
            setServicesLoading(false);
        }
    };

    const fetchSubServices = async (serviceId, defaultvalue) => {
        setSubServicesLoading(true);
        setServiceSubOptions([]);
        setSubServiceName('');
        setSubServicesError('');
        try {
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_')); // Get user info from localStorage
            const payload = {
                emp_id_auth: storedUserInfo?.emp_id,
                service_id: serviceId,
            };

            // API call to fetch GST services
            const response = await postData(ORG_GET_SUB_SERVICE_LIST_SEARCH, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        const subServices = responseData?.dataJ.map((service) => ({
                            label: service.service_sub_name,
                            value: service.service_sub_id,
                        }));
                        setServiceSubOptions(subServices);
                        if (defaultvalue === 'firstTime') {
                            const Services = {
                                label: '',
                                value: serviceId,
                            };
                            handleData(Services, subServices[0])
                        }
                    } else {
                        setSubServicesError(responseData?.info || 'Subservice search failed.');
                    }
                } else {
                    setSubServicesError(responseData?.info || 'Unable to fetch services');
                }
            }
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setSubServicesError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setSubServicesError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setSubServicesError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setSubServicesError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setSubServicesError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to search subservice options. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setSubServicesError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setSubServicesError(`Failed to search subservice options. Please check your network connection and try again.`);
            }
        } finally {
            setSubServicesLoading(false);
        }
    };

    const overViewReport = async (serviceName, subServiceName) => {
        setOverViewLoading(true);
        setOverViewReportError('');
        try {
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_')); // Get user info from localStorage
            const payload = {
                emp_id_auth: storedUserInfo?.emp_id,
                service_id: serviceName?.value,
                service_sub_id: subServiceName?.value,
                action: "overview_report"
            };

            // API call to fetch GST services
            const response = await postData(ORG_OVERVIEW_REPORT, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        const responseDataObject = responseData?.dataJ[0] || {};
                        const overViewReport = taskOverview.map((task) => ({
                            ...task,
                            value: responseDataObject[task.key] ?? "--",
                        }));
                        setTaskOverview(overViewReport);
                    } else {
                        setOverViewReportError(responseData?.info || 'Task overview status failed.');
                    }
                } else {
                    setOverViewReportError(responseData?.info || 'Unable to fetch task overview');
                }
            }
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setOverViewReportError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setOverViewReportError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setOverViewReportError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setOverViewReportError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setOverViewReportError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to get task overview. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setOverViewReportError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setOverViewReportError(`Failed to get task overview. Please check your network connection and try again.`);
            }
        } finally {
            setOverViewLoading(false);
        }
    }

    const taskStatusReport = async (serviceName, subServiceName) => {
        setTaskStatusLoading(true);
        setTaskStatusError('');
        try {
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_')); // Get user info from localStorage
            const payload = {
                emp_id_auth: storedUserInfo?.emp_id,
                service_id: serviceName?.value,
                service_sub_id: subServiceName?.value,
                action: "task_with_status"
            };

            // API call to fetch GST services
            const response = await postData(ORG_OVERVIEW_REPORT, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        const responseDataObject = responseData?.dataJ[0] || {};
                        const taskStatusReport = taskStatus.map((task) => ({
                            ...task,
                            value: responseDataObject[task.key] ?? "--",
                        }));
                        setTaskStatus(taskStatusReport);
                    } else {
                        setTaskStatusError(responseData?.info || 'Task status failed.');
                    }
                } else {
                    setTaskStatusError(responseData?.info || 'Unable to fetch task status');
                }
            }
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setTaskStatusError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setTaskStatusError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setTaskStatusError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setTaskStatusError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setTaskStatusError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to get task status. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setTaskStatusError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setTaskStatusError(`Failed to get task status. Please check your network connection and try again.`);
            }
        } finally {
            setTaskStatusLoading(false);
        }
    }

    const dateReport = async (serviceName, subServiceName) => {
        setDateStatusLoading(true);
        setDateStatusError('');
        try {
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_')); // Get user info from localStorage
            const payload = {
                emp_id_auth: storedUserInfo?.emp_id,
                service_id: serviceName?.value,
                service_sub_id: subServiceName?.value,
                action: "task_with_dates"
            };

            // API call to fetch GST services
            const response = await postData(ORG_OVERVIEW_REPORT, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        const responseDataObject = responseData?.dataJ[0] || {};
                        const dateStatusReport = dateStatus.map((task) => ({
                            ...task,
                            value: responseDataObject[task.key] ?? "--",
                        }));
                        setDatetatus(dateStatusReport);
                    } else {
                        setDateStatusError(responseData?.info || 'Date status failed.');
                    }
                } else {
                    setDateStatusError(responseData?.info || 'Unable to fetch task with due dates');
                }
            }
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setDateStatusError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setDateStatusError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setDateStatusError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setDateStatusError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setDateStatusError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to get date status. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setDateStatusError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setDateStatusError(`Failed to get date status. Please check your network connection and try again.`);
            }
        } finally {
            setDateStatusLoading(false);
        }
    }

    const fetchScheduleInfo = async () => {
        setScheduleLoading(true);
        setScheduleResError('');
        try {
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_')); // Get user info from localStorage
            const payload = {
                emp_id_auth: storedUserInfo?.emp_id,
                // "emp_id_auth": "10001",
                // "service_id": "10006",
                // "service_sub_id": "10006"
            };

            // API call to fetch GST services
            const response = await postData(ORG_GET_SCHEDULE_REPORT, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        if (responseData?.dataJ?.length > 0) {
                            setScheduleInfoList(responseData?.dataJ);
                        } else {
                            setScheduleResError(responseData?.info || 'No schedule info available.');
                        }

                    } else {
                        setScheduleResError(responseData?.info || 'Schedule Info failed.');
                    }
                } else {
                    setScheduleResError(responseData?.info || 'Unable to fetch schedule info.');
                }
            }
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setScheduleResError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setScheduleResError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setScheduleResError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setScheduleResError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setScheduleResError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to get Schedule Info. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setScheduleResError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setScheduleResError(`Failed to get Schedule Info. Please check your network connection and try again.`);
            }
        } finally {
            setScheduleLoading(false);
        }
    }

    const checkwiseReport = async (serviceName, subServiceName) => {
        setCheckwiseStatusLoading(true);
        setCheckwiseStatusError('');
        setCheckwiseStatusList([]);
        try {
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_')); // Get user info from localStorage
            const payload = {
                emp_id_auth: storedUserInfo?.emp_id,
                service_id: serviceName?.value,
                service_sub_id: subServiceName?.value,
                action: "checkwise_report"
            };

            // API call to fetch GST services
            const response = await postData(ORG_OVERVIEW_REPORT, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        const responseDataObject = responseData?.dataJ[0] || {};
                        const checkwiseStatusReport = checkwiseStatus.map((task) => ({
                            ...task,
                            value: responseDataObject[task.key] ?? "--",
                        }));
                        // setCheckwiseStatus(checkwiseStatusReport);
                        setCheckwiseStatusList(responseData?.dataJ);
                    } else {
                        setCheckwiseStatusError(responseData?.info || 'Checkwise report failed.');
                    }
                } else {
                    setCheckwiseStatusError(responseData?.info || 'Unable to fetch checkwise pending tasks.');
                }
            }
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setCheckwiseStatusError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setCheckwiseStatusError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setCheckwiseStatusError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setCheckwiseStatusError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setCheckwiseStatusError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to get checkwise status. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setCheckwiseStatusError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setCheckwiseStatusError(`Failed to get checkwise status. Please check your network connection and try again.`);
            }
        } finally {
            setCheckwiseStatusLoading(false);
        }
    }

    const fetchTaskCheckList = async (serviceName, subServiceName) => {
        setTaskCheckLoading(true);
        setTaskCheckError('');
        setTaskCheckList([]);
        try {
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_')); // Get user info from localStorage
            const payload = {
                emp_id_auth: storedUserInfo?.emp_id,
                service_id: serviceName?.value,
                service_sub_id: subServiceName?.value
            };

            // API call to fetch GST services
            const response = await postData(ORG_GET_SERVICE_LIST_SEARCH, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        const services = responseData?.dataJ.map((service) => ({
                            label: service.service_check_name,
                            value: service.service_check_id,
                        }));
                        // setCheckwiseStatus(checkwiseStatusReport);
                        setTaskCheckList(services);
                    } else {
                        setTaskCheckError(responseData?.info || 'Checkwise report failed.');
                    }
                } else {
                    setTaskCheckError(responseData?.info || 'Unable to fetch task check list.');
                }
            }
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setTaskCheckError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setTaskCheckError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setTaskCheckError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setTaskCheckError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setTaskCheckError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to get checkwise status. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setTaskCheckError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setTaskCheckError(`Failed to get task check. Please check your network connection and try again.`);
            }
        } finally {
            setTaskCheckLoading(false);
        }
    }

    const handleSubServices = (serviceName, defaultvalue) => {
        setServiceName(serviceName);
        setSelectedService(serviceName);
        fetchSubServices(serviceName?.value, defaultvalue);
        clearReportInfo();
    };

    const handleData = (serviceName, subServiceName) => {
        console.log('serviceName:', subServiceName)
        setSubServiceName(subServiceName);
        setSelectedServiceCategory(subServiceName);
        overViewReport(serviceName, subServiceName);
        taskStatusReport(serviceName, subServiceName);
        dateReport(serviceName, subServiceName);
        checkwiseReport(serviceName, subServiceName);
        fetchTaskCheckList(serviceName, subServiceName);
        toDoReport(serviceName, subServiceName);
    }

    useEffect(() => {
        //console.log("serviceName", serviceName);
        fetchServices();
        fetchGroupList();
        fetchYearList();
        fetchScheduleInfo();
        fetchNotificationstsList();
        setSelectedFinancialStatus(statusOptions[0]); // default for status
        setSelectedTaskwiseCheck(statusOptions[0]); // default for status
    }, []);

    const handlePendingTask = (type, taskData) => {
        console.log('handlePendingTask taskData :', taskData, 'selectedService', selectedService?.value);
        if (taskData?.value !== '--' && taskData?.value > 0) {
            const selectedInfo = {
                selService: selectedService || null,
                selServiceCategory: selectedServiceCategory || null,
                taskType: type || '',
                taskTypeName: taskData?.key || '',
                serviceCheckId: 0
            }
            navigate('/tasklist', { state: { selectedInfo: selectedInfo } });
        }
    }

    const handleCheckwise = (type, taskData) => {
        console.log('handleCheckwise taskData :', taskData, 'selectedService', selectedService?.value);
        if (taskData?.task_check_count !== '--' && taskData?.task_check_count > 0) {
            const selectedInfo = {
                selService: selectedService || null,
                selServiceCategory: selectedServiceCategory || null,
                taskType: type || '',
                taskTypeName: taskData?.service_check_name || '',
                serviceCheckId: taskData?.service_check_id || 0
            }
            console.log('handleSchedule selectedInfo : ', selectedInfo)
            navigate('/tasklist', { state: { selectedInfo: selectedInfo } });
        }
    }

    const handleSchedule = (type, taskData) => {
        console.log('handleSchedule taskData :', taskData, 'selectedService', selectedService?.value);
        // if (taskData?.sc_count === '--' && taskData?.sc_count > 0) {
        //     const selectedInfo = {
        //         selService: selectedService?.value || 0,
        //         selServiceCategory: selectedServiceCategory?.value || 0,
        //         taskType: type || '',
        //         taskTypeName: taskData?.key || ''

        //     }
        //     console.log('handleSchedule selectedInfo : ',selectedInfo)
        //     // navigate('/tasklist', { state: { selectedInfo: selectedInfo } });
        // }


        navigate('/schedule-reminder');
    }

    const handleFinancialYear = (type) => {
        console.log('selectedService', selectedService?.value);
        // if (userPermissions?.services?.per_name_sub_json?.view_task === 1) {
            const selectedInfo = {
                selService: selectedService || null,
                selServiceCategory: selectedServiceCategory || null,
                taskType: type || '',
                serviceCheckId: 0,
                financialYear: selectedFinancialYear,
                taskStatus: selectedFinancialStatus,
            }
            navigate('/tasklist', { state: { selectedInfo: selectedInfo } });
        // }
    }

    const handleTaskwise = (type) => {
        console.log('selectedService', selectedService?.value);
        // if (userPermissions?.services?.per_name_sub_json?.view_task === 1) {
            const selectedInfo = {
                selService: selectedService || null,
                selServiceCategory: selectedServiceCategory || null,
                taskType: type || '',
                groupId: selectedGroup,
                taskStatus: selectedTaskwiseCheck,
            }
            navigate('/tasklist', { state: { selectedInfo: selectedInfo } });
        // }
    }

    const [notificationLoading, setNotificationLoading] = useState(false);
    const [notificationError, setNotificationError] = useState('');
    const [notificationList, setNotificationList] = useState([])
    const fetchNotificationstsList = async () => {
        try {
            setNotificationLoading(true);
            setNotificationError('');
            setNotificationList([])
            // setTeamInfo({});
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            // Make the API call
            const response = await getData(`${ORG_GET_NOTIFICATIONS_LIST_DASHBOARD}?emp_id_auth=${storedUserInfo?.emp_id}`);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            const fetchedList = responseData?.dataJ
                            setNotificationList(fetchedList);
                            // selTeamInfo.current = responseData?.dataJ[0];
                        } else {
                            setNotificationError(responseData?.info || 'Data Not Found');
                        }
                    } else {
                        setNotificationError(responseData?.info || 'Failed to fetch  todo list. Please try again.');
                    }
                } else {
                    setNotificationError(responseData?.info || 'Failed to fetch todo list.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setNotificationError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setNotificationError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setNotificationError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setNotificationError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setNotificationError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch todo list. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setNotificationError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setNotificationError(`Failed to fetch todo list. Please check your network connection and try again.`);
            }
        } finally {
            setNotificationLoading(false);
        }
    }

    const fetchGroupList = async () => {
        try {
            setGroupListLoading(true);
            // setFieldConfigs((prevConfigs) =>
            //     prevConfigs.map((field) =>
            //         field.key === "group_name"
            //             ? { ...field, loading: true }
            //             : field
            //     )
            // );
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            // Make the API call
            const response = await getData(`${ORG_GET_GROUP_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            // Transforming the data
                            groupClientOptionsRef.current = await responseData?.dataJ.map(service => ({
                                label: service.group_name,
                                value: service.group_id
                            }));
                            setGroupClientOptions(groupClientOptionsRef.current)
                            // Update the fieldConfigs dynamically
                            // setFieldConfigs((prevConfigs) =>
                            //     prevConfigs.map((field) =>
                            //         field.key === "group_name"
                            //             ? { ...field, options: groupClientOptionsRef.current }
                            //             : field
                            //     )
                            // );
                        } else {
                            setGroupError(responseData?.info || 'Data Not Found');
                        }
                    } else {
                        setGroupError(responseData?.info || 'Failed to fetch inventory data. Please try again.');
                    }
                } else {
                    setGroupError(responseData?.info || 'Failed to fetch Task Categorie data.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setGroupError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setGroupError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setGroupError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setGroupError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setGroupError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Task Categorie data. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setGroupError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setGroupError(`Failed to fetch Task Categorie data. Please check your network connection and try again.`);
            }
        } finally {
            setGroupListLoading(false);
            // setFieldConfigs((prevConfigs) =>
            //     prevConfigs.map((field) =>
            //         field.key === "group_name"
            //             ? { ...field, loading: false }
            //             : field
            //     )
            // );
        }
    }

    const fetchYearList = async () => {
        try {
            setYearListLoading(true);
            setYearListError('')
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            // Make the API call
            const payLoad = { "code_id": "org_all_codes" }
            const response = await postData(ORG_GET_ALL_CODES_LIST, payLoad);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ) {
                            // Transforming the data
                            const yearListOptions = await responseData?.dataJ?.financial_year_codes_list.map(service => ({
                                label: service?.year_name,
                                value: service?.year_id,
                                isDefault: service?.is_default === 1
                            }));
                            setYearList(yearListOptions);

                            const defaultYear = yearListOptions.find(year => year.isDefault);
                            setSelectedFinancialYear(defaultYear || null); // setting default current financial year
                            setSelectedOverallYear(defaultYear || null); // setting default current financial year
                        
                            // Transforming the data
                            const periodOption = await responseData?.dataJ?.financial_period_codes_list.map(service => ({
                                label: service.pc_name,
                                value: service.pc_id
                            }));
                            setPeriodList(periodOption)
                            setSelectedOverallPeriod(periodOption[0]);
                        } else {
                            setYearListError(responseData?.info || 'Data Not Found');
                        }
                    } else {
                        setYearListError(responseData?.info || 'Failed to fetch financial year. Please try again.');
                    }
                } else {
                    setYearListError(responseData?.info || 'Failed to fetch financial year.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setYearListError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setYearListError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setYearListError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setYearListError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setYearListError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch financial year. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setYearListError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setYearListError(`Failed to fetch financial year. Please check your network connection and try again.`);
            }
        } finally {
            setYearListLoading(false);
        }
    }

    const fetchUserCount = async (selectedTaskCheck, selectedTaskCheck2) => {
        //console.log('get client')
        try {
            setCount('--');
            setCountError('');
            setCountLoading(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            // Make the API call
            const payLoad = {
                "emp_id_auth": storedUserInfo?.emp_id,
                "service_id": selectedService?.value || 0,
                "service_sub_id": selectedServiceCategory?.value || 0,
                "action": "userwise_report",
                "completed_check_id": selectedTaskCheck?.value || 0,
                "pending_check_id": selectedTaskCheck2?.value || 0,
            }
            const response = await postData(ORG_OVERVIEW_REPORT, payLoad);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            setCount(responseData?.dataJ[0]?.task_count);
                        } else {
                            setCountError(responseData?.info || 'No task available.');
                        }
                    } else {
                        setCountError(responseData?.info || 'Failed to fetch tasks. Please try again.');
                    }
                } else {
                    setCountError(responseData?.info || 'Failed to fetch tasks.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setCountError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setCountError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            } else {
                setCountError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setCountError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch tasks. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setCountError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setCountError(`Failed to fetch tasks. Please check your network connection and try again.`);
            }
        } finally {
            setCountLoading(false);
        }
    }

    const clearReportInfo = () => {
        setTaskOverview([
            { label: "Completed", key: "completed", value: "--" },
            { label: "Priority", key: "priority", value: "--" },
            { label: "In Progress", key: "inprogress", value: "--" },
            { label: "Not Started", key: "not_started", value: "--" },
            { label: "Hold", key: "hold", value: "--" },
            { label: "Delayed", key: "delayed", value: "--" },
            { label: "Long Due", key: "long_due", value: "--" },
        ])
        setTaskStatus([
            { label: "Task with Pending Issues", key: "task_with_pending_issues", value: "--" },
            { label: "Tasks kept on Hold", key: "tasks_kept_on_hold", value: "--" },
            { label: "Tasks with No Issues", key: "tasks_with_no_issues", value: "--" },
        ])
        setDatetatus([
            { label: "Due by Today", key: "due_by_today", value: "--" },
            { label: "Due within 7 Days", key: "due_within_7_days", value: "--" },
            { label: "Crossed Due Date", key: "crossed_due_date", value: "--" },
        ])
        setCheckwiseStatusList([])
    }

    const toDoReport = async (serviceName, subServiceName) => {
        setToDoLoading(true);
        setToDoReportError('');
        try {
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_')); // Get user info from localStorage
            const payload = {
                emp_id_auth: storedUserInfo?.emp_id,
                service_id: serviceName?.value,
                service_sub_id: subServiceName?.value,
                action: "to_do_list_report"
            };

            // API call to fetch GST services
            const response = await postData(ORG_OVERVIEW_REPORT, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        // const responseDataObject = responseData?.dataJ[0] || {};
                        // const overViewReport = taskOverview.map((task) => ({
                        //     ...task,
                        //     value: responseDataObject[task.key] ?? "--",
                        // }));
                        const responseDataObject = responseData?.dataJ?.[0] || {};

                        // Ensure completed and pending exist as arrays
                        responseDataObject.completed = Array.isArray(responseDataObject.completed) ? responseDataObject.completed : [];
                        responseDataObject.pending = Array.isArray(responseDataObject.pending) ? responseDataObject.pending : [];

                        // ✅ Update `toDoListData` state with merged values
                        setToDoListData([
                            {
                                taskStatus: "Completed",
                                taskwise: responseDataObject.completed[0]?.task_wise,
                                fileNo: responseDataObject.completed[0]?.file_no,
                                without: "--" // Placeholder if needed
                            },
                            {
                                taskStatus: "Pending",
                                taskwise: responseDataObject.pending[0]?.task_wise,
                                fileNo: responseDataObject.pending[0]?.file_no,
                                without: "--"
                            }
                        ]);
                        // setTaskOverview(overViewReport);
                    } else {
                        setToDoReportError(responseData?.info || 'Task overview status failed.');
                    }
                } else {
                    setToDoReportError(responseData?.info || 'Unable to fetch task overview');
                }
            }
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setToDoReportError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setToDoReportError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setToDoReportError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setToDoReportError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setToDoReportError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to get task overview. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setToDoReportError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setToDoReportError(`Failed to get task overview. Please check your network connection and try again.`);
            }
        } finally {
            setToDoLoading(false);
        }
    }

    const handleUserWiseReport = (type) => {
        console.log('selectedService', selectedService?.value);
        // if (userPermissions?.services?.per_name_sub_json?.view_task === 1) {
            const selectedInfo = {
                selService: selectedService || null,
                selServiceCategory: selectedServiceCategory || null,
                taskType: type || '',
                serviceCheckId: 0,
                completedChecks: selectedTaskCheck,
                pendingChecks: selectedTaskCheck2,
            }
            navigate('/tasklist', { state: { selectedInfo: selectedInfo } });
        // }
    }

    const handleOverallReport = (type) => {
        console.log('selectedService', selectedService?.value);
        // if (userPermissions?.services?.per_name_sub_json?.view_task === 1) {
            const selectedInfo = {
                selService: selectedService || null,
                selServiceCategory: selectedServiceCategory || null,
                taskType: type || '',
                serviceCheckId: 0,
                completedChecks: selectedOverallStatus,
                pendingChecks: selectedOverallCheck,
                financialPeriod: selectedOverallPeriod,
                financialYear: selectedOverallYear,
            }
            navigate('/tasklist', { state: { selectedInfo: selectedInfo } });
        // }
    }

    return {
        userPermissions,
        serviceOptions,
        serviceSubOptions,
        statusOptions,
        taskOverview,
        loading,
        handlePendingTask, handleCheckwise, handleSchedule,
        servicesLoading,
        servicesError,
        serviceName,
        setServiceName,
        subServiceName,
        setSubServiceName,
        subServicesLoading,
        subServicesError,
        handleSubServices,
        handleData,
        overViewLoading,
        overViewReportError,
        taskStatus,
        taskStatusLoading,
        taskStatusError,
        dateStatus,
        dateStatusLoading,
        dateStatusError,
        checkwiseStatus,
        checkwiseStatusLoading,
        checkwiseStatusError,
        scheduleInfoList,
        scheduleLoading,
        scheduleResError,
        scheduleInfoListLoading,
        checkwiseStatusList,
        notificationList,
        notificationError,
        notificationLoading,
        handleFinancialYear,
        cards,
        cards1,
        toDoListData,
        handleTaskwise,
        cards2, handleUserWiseReport,
        cards3, taskCheckList, taskCheckLoading, taskCheckError,
        count, countError, countLoading,
        handleOverallReport,
        toDoReportError, toDoLoading,
    };
};

export default GstServiceController;

